<template>
  <div>
    <v-row dense class="text-left">
      <v-col cols="12" sm="12" md="12"
        ><v-banner
          color="primary"
          class="mb-4"
          dark
          shaped
          single-line
          align="left"
        >
          <v-icon class="mr-2">mdi-account</v-icon> Información de paciente 
        </v-banner>
      </v-col>
    </v-row>

    <v-row dense class="ml-2">
      <v-col md="4" sm="12" cols="12">
        <strong>Id Paciente: </strong>
        <span class="error--text"> {{ model.idPatient }} </span>
      </v-col>
      <v-col md="4" sm="12" cols="12">
        <strong>Nombre completo: </strong>
        {{ dataPatient.fullName }}
      </v-col>
      <v-col md="4" sm="12" cols="12">
        <strong>Fecha de nacimiento: </strong>
        {{ dataPatient.parsedBirthDate }}
      </v-col>
    </v-row>
    <v-row dense class="text-left ml-2">
      <v-col md="4" sm="12" cols="12">
        <strong>CURP: </strong>
        {{ dataPatient.curp }}
      </v-col>
      <v-col md="4" sm="12" cols="12">
        <strong>Edad: </strong>
        {{ patientAge }}
      </v-col>
       <v-col md="3" sm="12" cols="12">
        <strong>Sexo: </strong>
        {{ patientGender }}
      </v-col>
      <v-col md="4" sm="12" v-if="job" cols="12">
        <strong>Ocupación: </strong>
        {{ job }}
      </v-col>
      <v-col md="4" sm="12" v-if="dataPatient.rfc" cols="12">
        <strong>RFC: </strong>
        {{ dataPatient.rfc }}
      </v-col>
      <v-col md="4" sm="12" v-if="dataPatient.educationName" cols="12">
        <strong>Escolaridad: </strong>
        {{  dataPatient.educationName }}
      </v-col>
    </v-row>
    <div v-if="details">
      <v-row dense class="ml-2" v-if="contactInformation">
        <v-col md="4" sm="12" cols="12">
          <strong>Teléfono móvil: </strong>
          {{ contactInformation.phone || "- - -" }}</v-col
        >
        <v-col md="4" sm="12" cols="12">
          <strong>Teléfono fijo: </strong>
          {{ contactInformation.homePhone || "- - -" }}
        </v-col>
        <v-col md="4" sm="12" cols="12">
          <strong>Correo electrónico: </strong>
          {{ contactInformation.email || "- - -" }}
        </v-col>
      </v-row>
      <v-row dense class="ml-2" v-if="address">
        <v-col md="12" sm="12" cols="12">
          <strong>Dirección: </strong>
          {{ address.fullAddress }}
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="js">
import { PatientInfoService  } from "@/app/services";
export default {
  name: "PatientInformation",
  props: {
    model: Object,
    details: Boolean
    // isCancelation: Boolean,
  },
  data() {
    return {
      dataPatient: {},
      patientGender: "",
      patientAge: "",
      patientBirth: "",
      photo: "",
      job: "",
      contactInformation: undefined,
      address: undefined,
    };
  },
  mounted() {
    // console.log(this.model);
    this.getDataConsulty();
    this.getPhotoByPatient();
  },
  // watch: {
  //   model: function() {
  //     console.log("aa");
  //      console.log(this.model);
  //     this.getDataConsulty();
  //   },
  // },
  methods: {
    getDataConsulty() {

      this.dataPatient = {};

      let idPatient = this.model.idPatient;
      let params = { idPatient: idPatient };

      PatientInfoService.getBasicInformation(params)
        .then((res) => {

          if (res.status === 200) {
            let { person, occupation, contactInformation, address, rfc, educationName  } = res.data;
            if (occupation) {
              this.job = occupation.name;
            } else {
              this.job = "No definida"
            }
            this.dataPatient = person;
            this.dataPatient.rfc = rfc;
            this.dataPatient.educationName = educationName;
            this.contactInformation = contactInformation;
            this.address = address;
            if(this.address){
              this.address.fullAddress = `${this.address.street}  #${this.address.outdoorNumber},`;
              this.address.fullAddress += ` ${this.address.colony},`;
              this.address.fullAddress += ` ${this.address.municipality},`;
              this.address.fullAddress += ` ${this.address.federalEntity},`;
              this.address.fullAddress += ` ${this.address.postalCode}`;
            }
            
            this.patientAge = this.$utilFront.obtainAgeWithLabel(
              this.dataPatient.birthDate
            );
           /*  this.patientBirth = this.$utilFront.formatDate(
              this.dataPatient.birthDate
            ); */
            if (this.dataPatient.gender === "H") {
              this.patientGender = "Masculino";
            } else if (this.dataPatient.gender === "M") {
              this.patientGender = "Femenino";
            } else if (this.dataPatient.gender === "X") {
              this.patientGender = "No binario";
            }
          }
          this.$emit("patientLoaded", res.data);
        })
        .then(() => { });
    },
    getPhotoByPatient() {
      //   <v-avatar size="120">
      //   <img
      //   :src="photo"
      //     alt="John"
      //   >
      // </v-avatar>
      // let params = { idPatient: this.model.idPatient };
      // PatientInfoService.getPhotoByPatient(params).then((response) => {
      //   this.photo = response.data || "xxx";
      // });
    },
  },
};
</script>

<style></style>
